import {
  CloseIcon,
  Icon,
  SidebarContainer,
  SidebarLang,
  SidebarLangImg,
  SidebarLangItem,
  SidebarWrapper,
  SidebarMenu,
  SidebarItem,
  SidebarLink,
  SidebarLinkR,
} from './SidebarElements';

import en from '../../img/lang/en.png';
import md from '../../img/lang/md.png';
import ru from '../../img/lang/ru.png';

import { MainPageText } from '../Library/LibraryMainPage';
import { useLanguage } from '../../hooks';

const Sidebar = ({ isOpen, toggle }) => {
  const { lang, setLanguage } = useLanguage();

  const scrollWithOffset = (el, offset) => {
    const elementPosition = el.offsetTop - offset;
    window.scroll({
      top: elementPosition,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    window.location.reload();
  };

  return (
    <SidebarContainer $isOpen={isOpen}>
      <Icon>
        <CloseIcon onClick={toggle} />
      </Icon>
      <SidebarWrapper onClick={toggle}>
        <SidebarMenu>
          <SidebarItem>
            <SidebarLink to="/#about" scroll={(el) => scrollWithOffset(el, 60)} onClick={toggle}>
              {MainPageText[lang].about}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to="/#product" scroll={(el) => scrollWithOffset(el, 60)} onClick={toggle}>
              {MainPageText[lang].equipment}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to="/#project" scroll={(el) => scrollWithOffset(el, 60)} onClick={toggle}>
              {MainPageText[lang].projects}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to="/#articles" scroll={(el) => scrollWithOffset(el, 60)} onClick={toggle}>
              {MainPageText[lang].articles}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to="/#contact" scroll={(el) => scrollWithOffset(el, 60)} onClick={toggle}>
              {MainPageText[lang].contacts}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLinkR to="/vacancy" onClick={toggle}>
              {MainPageText[lang].vacancy}
            </SidebarLinkR>
          </SidebarItem>
          <SidebarItem>
            <SidebarLang>
              <SidebarLangItem onClick={() => handleLanguageChange('en')}>
                <SidebarLangImg
                  src={en}
                  onClick={toggle}
                  className={lang === 'en' ? null : 'hideLang'}
                />
              </SidebarLangItem>
              <SidebarLangItem onClick={() => handleLanguageChange('md')}>
                <SidebarLangImg
                  src={md}
                  onClick={toggle}
                  className={lang === 'md' ? null : 'hideLang'}
                />
              </SidebarLangItem>
              <SidebarLangItem onClick={() => handleLanguageChange('ru')}>
                <SidebarLangImg
                  src={ru}
                  onClick={toggle}
                  className={lang === 'ru' ? null : 'hideLang'}
                />
              </SidebarLangItem>
            </SidebarLang>
          </SidebarItem>
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
